module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_upward_vector.279bc588.svg";